import { DocumentFragments } from '@/apollo/fragments/document';
import { Field } from '@/form/decorators/Field';
import { Form } from '@/form/decorators/Form';
import GraphQLForm from '@/form/GraphQLForm';
import { AboutDocument, IDocument } from '@/types/api';
import gql from 'graphql-tag';
import { DocumentForm } from '.';

@Form({
  apollo: {
    mutation: gql`
      mutation UpdateAbout($input: UpdateAboutInput!) {
        updateAbout(input: $input) {
          about {
            ...Document
          }
        }
      }
      ${DocumentFragments.Document}
    `,
    refetchQueries: ['About'],
  },
})
export class UpdateAboutForm extends GraphQLForm<IDocument> implements DocumentForm {
  @Field()
  public html: string;

  constructor(old: AboutDocument) {
    super();
    this.html = old.html;
  }
}
